import PropTypes from "prop-types";

export default function ColumnWidthType() {
  return PropTypes.oneOf(
    Array(13)
      .fill(null)
      .map((v, i) => i)
  );
}
